import { getPermissionsFromEntitlement } from "../constants/permissionKeys";

const normalizeKeys = (keys) => {
  if (!keys) return [];
  if (Array.isArray(keys)) return keys.filter(Boolean);
  return [keys].filter(Boolean);
};

export const hasPermission = (entitlement, permissionKey) => {
  const keys = normalizeKeys(permissionKey);
  if (keys.length === 0) return false;
  const permissions = getPermissionsFromEntitlement(entitlement);
  return keys.some((key) => permissions.includes(key));
};

export const hasAllPermissions = (entitlement, permissionKeys) => {
  const keys = normalizeKeys(permissionKeys);
  if (keys.length === 0) return false;
  const permissions = getPermissionsFromEntitlement(entitlement);
  return keys.every((key) => permissions.includes(key));
};

export const hasAnyPermission = (entitlement, permissionKeys) =>
  hasPermission(entitlement, permissionKeys);
